import { render, staticRenderFns } from "./Cabang.vue?vue&type=template&id=6b8e9afc&"
import script from "./Cabang.vue?vue&type=script&lang=js&"
export * from "./Cabang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports